angular.module('app.terms', ['ngRoute', 'ngResource', 'angular-jwt', 'ngFileUpload', 'bw.paging', 'uiGmapgoogle-maps', require('angular-sanitize')])
.config(['$routeProvider', function ($routeProvider) {
  $routeProvider.when('/service/terms', {
    template: require('./terms.html'),
    controller: 'termsCtrl',
  }).when('/service/terms/:type', {
    template: require('./modify.html'),
    controller: 'termsModifyCtrl',
  });
}])
.controller('termsCtrl', ($rootScope, $scope, $translate, $resource, $route, $location, $cookies, $routeParams, $window, AuthService, envService, uiGmapGoogleMapApi, TagConverter) => {
  $rootScope.mainmenu = 'service';
  $rootScope.menu = 'terms';
  const APIURL = envService.read('apiUrl');
  if (!AuthService.isAuthenticated()) {
    $location.path('/login');
    return;
  }
  $scope.title = $translate.instant('이용약관');
  $scope.termsList = [];
  const typeTerms = 'TERMS';
  const typePersonal = 'TERMS_PERSONAL';
  const typeLocation = 'TERMS_COLLECTION';
  const strTerms = $translate.instant('이용약관');
  const strTermsPersonal = $translate.instant('개인정보 취급방침');
  const strTermsLocation = $translate.instant('위치기반서비스 이용약관');

  $resource(`${APIURL}/admin/companyinfo`).get((data) => {
    $scope.termsList.push({ TYPE: typeTerms, TITLE: strTerms, CONTENTS: TagConverter.replaceForHtml(data.companyinfo.TERMS) });
    if (AuthService.loginMember().COUNTRY_CODE !== 'JP') {
      $scope.termsList.push({ TYPE: typePersonal, TITLE: strTermsPersonal, CONTENTS: TagConverter.replaceForHtml(data.companyinfo.TERMS_PERSONAL) });
      $scope.termsList.push({ TYPE: typeLocation, TITLE: strTermsLocation, CONTENTS: TagConverter.replaceForHtml(data.companyinfo.TERMS_COLLECTION) });
    }
  }, (err) => {
    console.error(err);
    if (err.data && err.data.msg) {
      alert(err.data.msg);
    } else {
      alert($translate.instant('알수 없는 에러 입니다.'));
    }
  });
  $scope.gotoDetail = (terms) => {
    $location.path(`/service/terms/${terms.TYPE}`);
  };
})
.controller('termsModifyCtrl', ($rootScope, $scope, $translate, $resource, $route, $location, $cookies, $routeParams, $window, AuthService, envService, uiGmapGoogleMapApi, TagConverter) => {
  $rootScope.mainmenu = 'service';
  $rootScope.menu = 'terms';
  const APIURL = envService.read('apiUrl');
  if (!AuthService.isAuthenticated()) {
    $location.path('/login');
    return;
  }
  const type = $routeParams.type;
  const typePersonal = 'TERMS_PERSONAL';
  const typeLocation = 'TERMS_COLLECTION';
  let termsTitle = '';
  if (type === typePersonal) {
    termsTitle = $translate.instant('개인정보 취급방침');
  } else if (type === typeLocation) {
    termsTitle = $translate.instant('위치기반서비스 이용약관');
  } else {
    termsTitle = $translate.instant('이용약관');
  }
  $scope.title = $scope.termsTitle;
  $scope.termsTitle = termsTitle;
  $scope.terms = '';
  $scope.modifyMode = false;

  $resource(`${APIURL}/admin/companyinfo/${type}`).get((data) => {
    $scope.terms = TagConverter.replaceForHtml(data.terms);
    console.log($scope.terms);
  }, (err) => {
    console.error(err);
    if (err.data && err.data.msg) {
      alert(err.data.msg);
    } else {
      alert($translate.instant('알수 없는 에러 입니다.'));
    }
  });
  $scope.gotoModify = () => {
    $scope.modifyMode = true;
    $scope.terms = TagConverter.replaceForTextArea($scope.terms);
  };
  $scope.gotoList = () => {
    $location.path('/service/terms/');
  };
  $scope.gotoModifySubmit = () => {
    console.log($scope.terms);
    $resource(`${APIURL}/admin/companyinfo/${type}`).save({ CONTENTS: $scope.terms }, (data) => {
      console.log(data);
      $scope.terms = TagConverter.replaceForHtml(data.terms);
      $scope.modifyMode = false;
      $location.path(`/service/terms/${type}`);
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
});



// WEBPACK FOOTER //
// ./src/app/service/terms/terms.js